import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRemoveAppPermissionsFromInstallsMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { GET_APP_GOVERNANCE_PERMISSIONS_QUERY } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.dfc.new';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
const ERROR_CONFIG = {
  message: 'Error removing app permissions from installs',
  alert: {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.errorBoundary.default.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.dataPermissions.removedAlert.error.message"
    })
  }
};
export function useRemoveAppPermissionsFromInstalls() {
  const {
    appId
  } = useApp();
  const [removeAppPermissionsFromInstalls, {
    loading,
    error
  }] = useRemoveAppPermissionsFromInstallsMutation({
    onCompleted: () => {
      FloatingAlertStore.addAlert({
        type: 'success',
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.dataPermissions.removedAlert.success.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.dataPermissions.removedAlert.success.message"
        })
      });
    },
    update: (cache, {
      data
    }) => {
      if (!data) {
        return;
      }
      const existingData = cache.readQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        }
      });
      if (!existingData) {
        return;
      }
      const {
        result: {
          requiredAppPermissions,
          optionalAppPermissions
        }
      } = existingData;
      const updatedRequiredPermissions = requiredAppPermissions.filter(permission => permission.isOnAppConfig);
      const updatedOptionalPermissions = optionalAppPermissions.filter(permission => permission.isOnAppConfig);
      cache.writeQuery({
        query: GET_APP_GOVERNANCE_PERMISSIONS_QUERY,
        variables: {
          appId
        },
        data: Object.assign({}, existingData, {
          result: Object.assign({}, existingData.result, {
            requiredAppPermissions: updatedRequiredPermissions,
            optionalAppPermissions: updatedOptionalPermissions
          })
        })
      });
    }
  });
  useCaptureError(error, ERROR_CONFIG);
  return {
    removeAppPermissionsFromInstalls,
    loading,
    error
  };
}